import { cn } from 'src/utils/className';

type ArrowConnectorProps = {
  className?: string;
  height?: number;
  color?: string;
  lineThickness?: number;
  arrowColor?: string;
  arrowSize?: number;
  noArrow?: boolean;
};

export function ArrowConnector({
  height = 20,
  color = 'bg-neutral-200',
  arrowColor = 'text-neutral-200',
  arrowSize = 20,
  lineThickness = 2,
  noArrow = false,
  className = '',
}: ArrowConnectorProps) {
  return (
    <div className={cn('relative w-full h-full', className)}>
      <div
        className={cn('relative bottom-0 left-1/2 -translate-x-1/2', color)}
        style={{ width: lineThickness, height }}
      />
      {!noArrow && (
        <svg
          width={arrowSize}
          height={arrowSize}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          className={cn(
            'absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2',
            arrowColor,
          )}
        >
          <path
            d="M6 10L12 16L18 10"
            stroke="currentColor"
            strokeWidth={lineThickness + 1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </div>
  );
}

export default ArrowConnector;
